import React, {useCallback, useEffect, useState, useMemo} from 'react';
import Popover from '@mui/material/Popover';
import QuadralDropZone from "@quadral/quadral-component-common/dist/components/dropzone";
import QuadralButton from '@quadral/quadral-component-common/dist/components/button';
import QuadralModal from '@quadral/quadral-component-common/dist/components/modal';
import QuadralContainer from "@quadral/quadral-component-common/dist/components/container";
import QuadralButtonIcon from "@quadral/quadral-component-common/dist/components/buttonIcon";
import QuadralAutocomplete from "@quadral/quadral-component-common/dist/components/autocomplete";
import QuadralTextField from "@quadral/quadral-component-common/dist/components/textField";
import QuadralTooltip from '@quadral/quadral-component-common/dist/components/tooltip';
import QuadralTypography from '@quadral/quadral-component-common/dist/components/typography';
import QuadralCard from '@quadral/quadral-component-common/dist/components/card';
import QuadralBadge from "@quadral/quadral-component-common/dist/components/badge";
import QuadralForm from "@quadral/quadral-component-common/dist/components/form";
import {themeColors} from "../../../../theme/themeConstants";
import Grid from '@mui/material/Grid';
import {
    faAngleRight,
    faChevronLeft,
    faChevronRight,
    faExpand,
    faExclamation,
    faListCheck,
    faQuestion,
    faCopy,
    faBars
} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import ForceUploadModal from './ForceUploadModal';
import {onlineProcessesService} from '../../../../services';

const refusalReasonOptions = [
    {
        code: "",
        label: ""
    },
    {
        code: "autre",
        label: "Autre"
    },
    {
        code: "illisible",
        label: "Illisible"
    },
    {
        code: "incomplet",
        label: "Incomplet"
    },
    {
        code: "mauvais_document",
        label: "Mauvais document"
    },
    {
        code: "mauvaise_periode",
        label: "Mauvaise période"
    },
    {
        code: "mauvais_individu",
        label: "Mauvais individu"
    },
    {
        code: "correction_declaration",
        label: "Correction déclaration"
    }
]

const fieldNameMapping = {
    //Avis imposition
    "taxType": "Type d’avis",
    "taxYear": "Année de l’avis",
    "TAX_ASSESSMENT-CODE_2DDOC_INCOME_YEAR": "Année d'imposition",
    "numberOfParts": "Nombre de parts",
    "householdSituation": "Situation maritale",
    "taxAmount": "Montant de l’impôt",
    "grossIncome": "Revenu brut global",
    "TAX_ASSESSMENT-CODE_2DDOC_TAX_NUMBER_1": "Numéro fiscal 1",
    "TAX_ASSESSMENT-CODE_2DDOC_TAX_NUMBER_2": "Numéro fiscal 2",
    "TAX_ASSESSMENT-CODE_2DDOC_FISCAL_EARNINGS_REFERENCE": "Revenu Fiscal de Référence",
    //Passeport
    "PASSPORT-NAME": "Nom",
    "PASSPORT-FIRSTNAME": "Prénom(s)",
    "PASSPORT-BIRTHDATE": "Né(e) le",
    "birthPlace": "Né(e) à",
    //CNI
    "LASTNAME": "Nom",
    "FIRSTNAME": "Prénom(s)",
    "BIRTHDATE": "Né(e) le",
    "BIRTHPLACE": "Né(e) à",
}

const propertyMapping = {
    //Avis imposition
    "householdSituation": "familySituation",
    "numberOfParts": "nbrOfTaxShares",

    //Passeport
    "PASSPORT-NAME": "lastname",
    "PASSPORT-FIRSTNAME": "firstname",
    "PASSPORT-BIRTHDATE": "birthDate",
    "birthPlace": "birthCity",
    //CNI
    "LASTNAME": "lastname",
    "FIRSTNAME": "firstname",
    "BIRTHDATE": "birthDate",
    "BIRTHPLACE": "birthCity",
}

export default function SupportingDocumentDetail({
                                                     showLoader,
                                                     hideLoader,
                                                     showRefuseModal,
                                                     setShowRefuseModal,
                                                     showReassignModal,
                                                     setShowReassignModal,
                                                     setFiles,
                                                     files,
                                                     document,
                                                     persons,
                                                     selectedCurrentPerson,
                                                     updatedData,
                                                     personId,
                                                     id,
                                                     participation,
                                                     status,
                                                     setStatus,
                                                     statusIcon,
                                                     setStatusIcon,
                                                     getStatus,
                                                     getStatusIcon,
                                                     getCategory,
                                                     getPersonGenre,
                                                     getPersonName,
                                                     getPersonVialinkControlResponse,
                                                     refuseFormData,
                                                     setRefuseFormData,
                                                     canUpdate,
                                                     onPrevious,
                                                     onNext,
                                                     displayDocumentList,
                                                     collapseToggle,
                                                     emptyRefusalModal,
                                                     supportingDocsOnlyTotal,
                                                     updateData,
                                                     refreshPersonsData,
                                                     quadralToast,
                                                     openDocumentFullscreen,
                                                     isN3,
                                                     isControlled,
                                                     isDisabledUploads,
                                                     ...props
                                                 }) {
    const [fullPersonName, setFullPersonName] = useState(null);
    // const [personNationality, setPersonNationality] = useState('');
    const [originalPersonSheet, setOriginalPersonSheet] = useState('');
    const [personSheet, setPersonSheet] = useState('');
    // const [personBirthDate, setPersonBirthDate] = useState('');
    const [vialinkResponse, setVialinkResponse] = useState('');
    const [analyzedFields, setAnalyzedFields] = useState([]);
    const [fieldsToDisplay, setFieldsToDisplay] = useState('');

    const [category, setCategory] = useState('');
    const [confidenceIndex, setConfidenceIndex] = useState('');

    const [documentLink, setDocumentLink] = useState(null);

    const [showDisassociationModal, setShowDisassociationModal] = useState(false);
    const [forceUploadModalOpen, setForceUploadModalOpen] = useState(false);
    const [displayValidation, setDisplayValidation] = useState(false);
    const [displayRefusal, setDisplayRefusal] = useState(false);
    // const [displayUpload, setDisplayUpload] = useState(false);

    const [anchorEl, setAnchorEl] = useState(null);
    const [showHelpPopover, setShowHelpPopover] = useState(false);

    const [detailFormData, setDetailFormData] = useState({
        rfr: '',
        year: null
    });

    const memoizedAnalyzedFields = useMemo(() => {
        if (!document?.vialinkId || !vialinkResponse) {
            return [];
        }
        return getAnalyzedFields(vialinkResponse, document.vialinkId);
    }, [document?.vialinkId, vialinkResponse]);

    useEffect(() => {
        if (showRefuseModal === false) setFiles([]);
    }, [showRefuseModal, setFiles])

    useEffect(() => {
        if (showDisassociationModal === false) setFiles([]);
    }, [showDisassociationModal, setFiles])

    function displayDisassociationModal() {
        setShowDisassociationModal(true)
    }

    const getConfidenceIndex = useCallback(
        (doc) => {
            const documents = vialinkResponse?.documents;
            if (!documents || !doc?.vialinkId) {
                setConfidenceIndex('Inconnu');
                return;
            }

            for (const parent of documents) {
                for (const vialinkDocument of parent.documents || []) {
                    if (vialinkDocument?.id === Number(doc?.vialinkId) && vialinkDocument.score !== undefined) {
                        setConfidenceIndex(vialinkDocument.score);
                        return;
                    }
                }
            }
            setConfidenceIndex('Inconnu');
        }, 
        [vialinkResponse]
    );

    useEffect(() => {
        if (!document) return;
        
        getConfidenceIndex(document);
        setStatus(getStatus(document));
        setStatusIcon(getStatusIcon(document));
        setCategory(getCategory(document));
        
        const genre = getPersonGenre(document.personId);
        const name = getPersonName(document.personId);
        setVialinkResponse(getPersonVialinkControlResponse(document.personId));
        setFullPersonName(genre + ' ' + name);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [document?.id, document?.personId, getCategory, getConfidenceIndex, getPersonGenre, getPersonName, getPersonVialinkControlResponse, getStatus, getStatusIcon, setStatus, setStatusIcon]);
    
    function formatDate(dateStr, separator = '/') {
        if (dateStr) {
            const [year, month, day] = dateStr.split(/[#/\- ]+/);
            return `${day}${separator}${month}${separator}${year}`;
        }
    }

    useEffect(() => {
        const selectedPersonSheetData = persons?.find(p => p.id === selectedCurrentPerson);
        let selectedPersonSheet;
        try {
            if (selectedPersonSheetData) {
                const updatedSheet = {...selectedPersonSheetData};
                Object.keys(updatedSheet).forEach((key) => {
                    if (key.includes('Date') && updatedSheet[key]) {
                        const [year, month, day] = updatedSheet[key].split(/[#/\- ]+/);
                        updatedSheet[key] = `${day}/${month}/${year}`;
                    }
                });
                selectedPersonSheet = updatedSheet;
            }
        } catch {
            selectedPersonSheet = undefined;
        }
        setOriginalPersonSheet(selectedPersonSheet);
        setPersonSheet(selectedPersonSheet);
    }, [document, persons, selectedCurrentPerson]);

    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    const displayDocument = useCallback(async (attempt = 0) => {
        showLoader();

        try {
            const doc = await onlineProcessesService.displaySupportingDocumentFile(
                props.id,
                personId,
                document?.id
            );
            if (doc && doc.data && doc.data.size !== 0) {
                const byteCharacters = atob(doc.data);
                const byteNumbers = Array.from(byteCharacters, c => c.charCodeAt(0));

                const blob = new Blob(
                    [new Uint8Array(byteNumbers)],
                    {type: "application/pdf"}
                );

                const url = window.URL.createObjectURL(blob);
                setDocumentLink(url);
            } else if (attempt === 1) {
                await sleep(500);
                await displayDocument();
            }
        } catch (error) {
            console.error("Erreur lors du chargement du document :", error);
            quadralToast.error(error.response?.data?.message || 'Erreur lors du chargement du document.');
        } finally {
            hideLoader();
        }
    }, [props.id, personId, document?.id, showLoader, hideLoader, quadralToast]);

    useEffect(() => {
        if (!forceUploadModalOpen && status === 'A fournir') {
            deleteSupportingDocument();
            setFiles([]);
        }
    }, [forceUploadModalOpen]) // eslint-disable-line react-hooks/exhaustive-deps

    function deleteSupportingDocument() {
        const valuesAPI = {
            participationId: participation?.id,
            personRecordId: personId,
            supportingDocumentId: document.id,
        };
        onlineProcessesService.deleteSupportingDocument(valuesAPI);
    }

    async function uploadFiles(force = false) {
        setStatus("À vérifier");
        showLoader();
        const formData = new FormData();

        files.forEach((file, index) => {
            const fieldName = index === 0 ? "file" : `file${index + 1}`;
            formData.append(fieldName, file);
        });
        const valuesAPI = {
            participationId: participation?.id,
            personRecordId: personId,
            supportingDocumentId: document.id,
            forceUpload: force
        };
        await onlineProcessesService.uploadSupportingDocumentFile(valuesAPI, formData)
            .then(response => {
                hideLoader();
                quadralToast.success('Fichier(s) ajouté(s) avec succès.');
                displayDocument(1);
                setShowRefuseModal(false);
                setFiles([]);

                if (document) {
                    document.status = "attente_verification";
                }
                updateData();
            })
            .catch(error => {
                setStatus("A fournir");
                hideLoader();
                const isForceUploadError =
                    error.response?.status === 400 &&
                    error.response?.data?.message?.startsWith('Mauvais type de document téléversé')
                if (isForceUploadError) {
                    setForceUploadModalOpen(true);
                } else {
                    const {forceUpload, ...TrimValuesAPI} = valuesAPI;
                    onlineProcessesService.deleteSupportingDocument(TrimValuesAPI);
                    quadralToast.error(error.response?.data?.message || 'Erreur lors du téléversement.');
                }
            });
    }

    function getAnalyzedFields(vialinkResponse, rawDocumentVialinkId) {
        const documentVialinkId = Number(rawDocumentVialinkId);
        if (!vialinkResponse || !vialinkResponse?.control?.result || !vialinkResponse?.control?.result?.checkResults || !documentVialinkId) {
            return [];
        }
        let extractedFields = [];

        const documents = vialinkResponse?.documents;
        const checkResults = vialinkResponse?.control?.result?.checkResults;

        checkResults.forEach((check) => {
            check.sources.forEach((source) => {
                if (source?.documentId === documentVialinkId) {
                    extractedFields.push({
                        name: check.name,
                        value: source.value
                    });
                }
            });
        });

        documents?.forEach(parent => {
            if (parent.type === "PASSPORT") {
                parent.documents.forEach(document => {
                    if (String(document.id) === String(documentVialinkId)) {
                        const birthPlaceData = document?.data?.find(d => d.key === "BIRTHPLACE")?.data;
                        if (birthPlaceData && !extractedFields.some(f => f.name === "birthPlace")) {
                            extractedFields.push({
                                name: "birthPlace",
                                value: birthPlaceData
                            });

                        }
                    }
                })
            } else if (parent.type === "STATE_ID") {
                const cniFields = ["LASTNAME", "FIRSTNAME", "BIRTHDATE", "BIRTHPLACE"];
                parent.documents.forEach(document => {
                    if (String(document.id) === String(documentVialinkId)) {
                        cniFields.forEach(key => {
                            const field = document?.data?.find(d => d.key === key);
                            const alreadyExists = extractedFields.some(f => f.name === key);

                            if (!alreadyExists && field?.data) {
                                extractedFields.push({
                                    name: key,
                                    value: field.data
                                });
                            }
                        })
                    }
                })
            }

            parent?.documents?.forEach((document) => {
                if (document?.id === documentVialinkId) {
                    const taxData = document?.data?.find(d => d.key === "TAX_ASSESSMENT")?.data;
                    if (taxData) {
                        const fieldsToExtract = [
                            "taxType",
                            "taxYear",
                            "numberOfParts",
                            "householdSituation",
                            "taxAmount",
                            "grossIncome"
                        ];
                        fieldsToExtract.forEach((field) => {
                            const alreadyExists = extractedFields.some(f => f.name === field);
                            if (!alreadyExists) {
                                extractedFields.push({
                                    name: field,
                                    value: taxData[field]
                                });
                            }
                        });
                        const rfrFrom2DDOC = extractedFields.find(f => f.name === "TAX_ASSESSMENT-CODE_2DDOC_FISCAL_EARNINGS_REFERENCE");
                        if (rfrFrom2DDOC) {
                            if (!rfrFrom2DDOC.value && taxData.references?.referenceTaxIncome) {
                                rfrFrom2DDOC.value = taxData.references.referenceTaxIncome;
                            }
                        } else if (taxData.references?.referenceTaxIncome) {
                            extractedFields.push({
                                name: "TAX_ASSESSMENT-CODE_2DDOC_FISCAL_EARNINGS_REFERENCE",
                                value: taxData.references.referenceTaxIncome
                            });
                        }
                    }
                }
            });
        });
        return extractedFields;
    }

    function handleField(fieldName, value) {
        setRefuseFormData(formData => ({
            ...formData,
            [fieldName]: value,
        }))
    }

    function handleRFRFields(fieldName, value) {
        setDetailFormData(formData => ({
            ...formData,
            [fieldName]: value,
        }))
    }

    function translateFieldName(fieldName) {
        return fieldNameMapping[fieldName] || fieldName;
    }

    function translatePropertyName(fieldName) {
        return propertyMapping[fieldName] || fieldName;
    }

    function copyFieldValue(fieldName, fieldValue) {
        if (fieldName === "TAX_ASSESSMENT-CODE_2DDOC_FISCAL_EARNINGS_REFERENCE") {
            setDetailFormData(prev => ({...prev, rfr: fieldValue}));
        } else if (fieldName === "TAX_ASSESSMENT-CODE_2DDOC_INCOME_YEAR") {
            setDetailFormData(prev => ({...prev, year: fieldValue}));
        } else {
            setPersonSheet(prev => ({
                ...prev,
                [fieldName]: fieldValue
            }));
        }
    }

    async function isChangedRFR() {
        const response = await onlineProcessesService.getIncomeAndCharges(
            document?.surveyParticipationId,
            document?.personId
        );
        const existingRFR = response?.find(
            income => income?.type === 'RFR'
        );

        const rfrHasChanged = existingRFR?.taxAmount !== detailFormData.rfr;
        const yearHasChanged = existingRFR?.year !== detailFormData.year;

        if (rfrHasChanged || yearHasChanged) {
            return {
                rfr: detailFormData.rfr,
                year: detailFormData.year
            };
        } else {
            return null;
        }
    }

    function updateRecordPatch() {
        const patches = [];
        const fields = ['birthDate', 'firstname', 'lastname'];
        const hasChanges = fields.some(field => originalPersonSheet[field] !== personSheet[field]);

        if (hasChanges) {
            const changedFields = fields.filter(field => {
                const oldVal = originalPersonSheet[field];
                const newVal = personSheet[field]?.trim();

                if (newVal === null || newVal === undefined || newVal === '') return false;
                return oldVal !== newVal;
            });

            changedFields.forEach(field => {
                if (field === 'birthDate') personSheet[field] = formatDate(personSheet[field], '-');
                patches.push({
                    op: "replace",
                    path: `${field}`,
                    value: personSheet[field]
                });
                if (field === 'birthDate') personSheet[field] = formatDate(personSheet[field]);
            });
            return patches;
        } else {
            return;
        }
    }

    async function updateRecord(jsonPatch) {
        try {
            showLoader();
            await onlineProcessesService.patchPersonRecord(
                participation?.id,
                personId,
                jsonPatch
            );

            if (props.refreshPersonsData) {
                await props.refreshPersonsData()
                    .then(() => {
                    }).catch(() => {
                        return;
                    });
            }
        } finally {
            hideLoader();
        }
    }

    async function validateDocument() {
        showLoader();

        const categoryID = ['piece_identite', 'Justificatif_identite_Adulte', 'Justificatif_identite_Enfant']
        const docCategory = document.category;

        try {
            if (categoryID.includes(docCategory)) {
                const updatePatch = updateRecordPatch();
                if (updatePatch) {
                    await updateRecord(updatePatch);
                }
            }

            if (docCategory === "RFR") {
                const rfrValueToSave = await isChangedRFR();
                if (rfrValueToSave) {
                    await saveRFR(rfrValueToSave, true);
                }
            }

            await onlineProcessesService.validateSupportingDocument(
                document?.surveyParticipationId,
                document?.personId,
                document?.id
            );

            const updatedFormData = {status: 'valide'};
            setStatus('Validé');
            setStatusIcon(getStatusIcon(updatedFormData));

            document.status = "valide";

            updateData();
            quadralToast.success("Pièce justificative validée avec succès");
            onNext();
        } catch (error) {
            quadralToast.error(error.response?.data?.message || "Erreur lors de la validation de la pièce");
        } finally {
            hideLoader();
        }
    }

    function refuseSupportingDocument() {
        if(!(refuseFormData.refusalReason && refuseFormData.refusalReason !== '')) {
            return;
        }
        emptyRefusalModal();
        updateSupportingDocument('refuse', 'Refusé');
    }

    function updateSupportingDocument(newStatus, statusName) {
        showLoader();

        const updatedFormData = {status: newStatus};
        const body = {
            id: document?.id,
            surveyParticipationId: document?.surveyParticipationId,
            personId: document?.personId,
            refusalReason: refuseFormData.refusalReason,
            refusalReasonDetails: refuseFormData.refusalReasonDetails,
            category: document?.category,
            status: newStatus,
            type: document?.type
        }

        onlineProcessesService.updateSupportingDocument({
                participationId: document?.surveyParticipationId,
                personRecordId: document?.personId,
                supportingDocumentId: document?.id
            }, body
        ).then(response => {
            setStatus(statusName);
            setStatusIcon(getStatusIcon(updatedFormData));

            document.status = newStatus;
            document.refusalReason = refuseFormData.refusalReason;
            document.refusalReasonDetails = refuseFormData.refusalReasonDetails;

            updateData();
            hideLoader();
            if (newStatus === 'refuse') {
                quadralToast.success("Pièce justificative refusée avec succès");
                onNext();
            }
        }).catch(error => hideLoader());

    }

    async function reassignDocument() {
        try {
            if (document?.status === "a_fournir") {
                const errormessage = "Il n'y a pas de document assigné à cette pièce.";
                quadralToast.error(errormessage);
                throw new Error(errormessage);
            }
            showLoader();
            const participationId = document?.surveyParticipationId;
            const personRecordId = document?.personId;
            const supportingDocumentId = document?.id;
            await onlineProcessesService.updateDocumentParent(participationId, personRecordId, supportingDocumentId).then(response => {
                updateSupportingDocument('a_fournir', 'A fournir');
            });
        } catch (error) {
            hideLoader();
            console.error("Erreur lors de la réassignation : ", error);
            return null;
        }
        hideLoader();
    }

    useEffect(() => {
        if (document?.id && personId) {
            setDocumentLink(null);
            displayDocument();
        } else {
            setDocumentLink(null);
        }
    }, [document?.id, personId, updatedData, displayDocument]);

    useEffect(() => {
        setAnalyzedFields(memoizedAnalyzedFields);
        
        const mappingKeys = Object.keys(fieldNameMapping);
        setFieldsToDisplay(memoizedAnalyzedFields.filter(item => mappingKeys.includes(item.name)).length);
    }, [memoizedAnalyzedFields]);

    useEffect(() => {
        // setDisplayUpload(props?.document?.status === "a_fournir")
        setDisplayValidation(displayRefusal && document?.status !== "valide" && document?.status !== "a_fournir")
        setDisplayRefusal(document?.status !== "refuse" && document?.status !== "supprime")
        if (document?.surveyParticipationId && document?.personId) {
            fetchAndSetRFR().then();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props?.document, document, updatedData]);

    async function fetchAndSetRFR() {
        try {
            const response = await onlineProcessesService.getIncomeAndCharges(
                document?.surveyParticipationId,
                document?.personId
            );
            const existingRFR = response.find(
                income => income?.type === 'RFR'
            );

            if (existingRFR) {
                setDetailFormData({
                    rfr: existingRFR.taxAmount,
                    year: existingRFR.year
                });
            } else {
                setDetailFormData({
                    rfr: "",
                    year: null
                });
            }
            return existingRFR;
        } catch (error) {
            console.error("Erreur lors de la récupération des données RFR : ", error);
            return null;
        }
    }

    async function saveRFR(value = null, validation = false) {
        showLoader();

        try {
            const response = await onlineProcessesService.getIncomeAndCharges(
                document?.surveyParticipationId,
                document?.personId
            );

            const existingRFR = response.find(
                income => income?.type === 'RFR'
            );

            const participationId = document?.surveyParticipationId;
            const personRecordId = document?.personId;
            const taxAmount = parseFloat(value?.rfr ?? detailFormData.rfr);
            const year = parseFloat(value?.year ?? detailFormData.year);

            if (!existingRFR) {
                const newRFR = {
                    type: 'RFR',
                    taxAmount,
                    status: 'valide',
                    nature: 'Revenu_fiscal_de_reference',
                    personId: personRecordId,
                    surveyParticipationId: participationId,
                    year: year
                };

                await onlineProcessesService.createIncomeAndCharges({participationId, personRecordId}, newRFR);
                quadralToast.success('Revenu Fiscal de Référence créé avec succès');
            } else {
                const updatedRFR = {
                    personId: personRecordId,
                    taxAmount,
                    status: 'valide',
                    nature: 'Revenu_fiscal_de_reference',
                    year: year
                };

                await onlineProcessesService.updateIncomeAndCharges(
                    {participationId, personRecordId, incomesAndChargesId: existingRFR.id},
                    updatedRFR
                );
                quadralToast.success('Revenu Fiscal de Référence mis à jour avec succès');
            }
            if (!validation) updateData();
        } catch (error) {
            quadralToast.error(
                error.response?.data?.message ||
                'Erreur lors de l\'enregistrement du RFR'
            );
        } finally {
            hideLoader();
        }
    }

    return (
        <>
            <ForceUploadModal
                open={forceUploadModalOpen}
                setOpen={setForceUploadModalOpen}
                uploadFiles={uploadFiles}
                participationId={participation?.id}
                personRecordId={personId}
                supportingDocumentId={document?.id}
            />
            <QuadralContainer orientation='row' sx={{gap: '1rem', height: '100%'}}>
                <QuadralContainer orientation='column' sx={{height: '100%'}} xl={7} md={7} sm={12}>
                    <QuadralContainer style={{marginBottom: '10px', display: 'flex', alignItems: 'center', gap: '0.5rem', flexFlow: 'wrap'}}>
                        {!displayDocumentList && (
                            <QuadralButtonIcon
                                icon={<FontAwesomeIcon icon={faBars}/>}
                                style={{
                                    maxWidth: displayDocumentList ? "100%" : "10%",
                                    cursor: "pointer",
                                    pointerEvents: "auto"
                                }}
                                onClick={collapseToggle}
                            />
                        )}
                        <QuadralTypography variant='normal' style={{marginRight: '5px'}}>
                            <b>{fullPersonName}</b> : {category}
                        </QuadralTypography>
                        <QuadralContainer orientation='row' sx={{justifyContent: 'space-between', gap: '0.25rem', alignItems: 'center'}}>
                            <QuadralBadge
                                icon={statusIcon}
                                label={status}
                                color={status === 'Validé' ? 'success'
                                    : status === 'Refusé' ? 'error'
                                        : status === 'A valider' ? 'info'
                                            : status === 'En attente de vérification' ? 'info'
                                                : 'secondary'
                                }
                            />
                        {!(document?.status === 'a_fournir' || document?.status === undefined || isN3)  && (
                            <QuadralButton
                                label="Plein écran"
                                title="Plein écran"
                                color="secondary"
                                disabled={!documentLink}
                                onClick={() => openDocumentFullscreen?.(documentLink, `${fullPersonName} : ${category}`)}
                                startIcon={<FontAwesomeIcon icon={faExpand}/>}
                            />
                        )}
                        </QuadralContainer>
                    </QuadralContainer>
                    {documentLink && documentLink.length > 0 && props?.document?.status !== "a_fournir" ? (
                        <object type='application/pdf' width="100%" height="100%"
                                data={`${documentLink} #zoom=FitH`} aria-label="Document PDF"/>
                    ) : (
                        (!isDisabledUploads && !(isN3)) && (
                            <QuadralDropZone
                                files={files}
                                onFilesChange={setFiles}
                                accept={{
                                    'application/pdf': ['.pdf'],
                                    'image/*': []
                                }}
                                maxFiles={5}
                                maxTotalSize={8 * 1024 * 1024}
                                onUpload={(() => uploadFiles())}
                            />
                        )
                    )}
                </QuadralContainer>
                {!(document?.status === 'a_fournir' || document?.status === undefined) && (
                    <QuadralContainer orientation='column' xl={5} md={5} sm={12} 
                        sx={{gap: '10px'}}>
                        <QuadralContainer orientation='row'>
                            <QuadralContainer orientation='row' xl={5}>
                                <QuadralTooltip title="Précédent" style={{width: 'fit-content'}}>
                                    <QuadralButtonIcon
                                        size='small'
                                        disabled={document?.globalIndex === 2}
                                        onClick={() => {
                                            onPrevious();
                                            emptyRefusalModal();
                                        }}
                                        icon={<FontAwesomeIcon icon={faChevronLeft}/>}
                                    />
                                </QuadralTooltip>

                                <span style={{fontSize: "1.1rem", margin: "0 1rem 0 1rem"}}>
                                    {document?.globalIndex - 1}/{supportingDocsOnlyTotal}
                                </span>

                                <QuadralTooltip title="Suivant" style={{width: 'fit-content'}}>
                                    <QuadralButtonIcon
                                        size='small'
                                        disabled={(document?.globalIndex - 1) === (supportingDocsOnlyTotal)}
                                        onClick={() => {
                                            onNext();
                                            emptyRefusalModal();
                                        }}
                                        icon={<FontAwesomeIcon icon={faChevronRight}/>}
                                    />
                                </QuadralTooltip>
                            </QuadralContainer>
                        {!isControlled && (<>
                            {!isN3 ? (<>
                                <QuadralContainer orientation='right' xl={7} sx={{gap: '10px'}}>
                                    <QuadralButton
                                        endIcon={<FontAwesomeIcon icon={faAngleRight}/>}
                                        label="Accepter et suivant"
                                        disabled={!displayValidation || !canUpdate}
                                        color='success'
                                        onClick={() => validateDocument()}
                                    >
                                        Valider
                                    </QuadralButton>
                                    <QuadralButton
                                        endIcon={<FontAwesomeIcon icon={faAngleRight}/>}
                                        label="Refuser et suivant"
                                        disabled={!displayRefusal || !canUpdate}
                                        color='error'
                                        onClick={() => setShowRefuseModal(true)}
                                    >
                                        Refuser
                                    </QuadralButton>
                                </QuadralContainer>
                            </>) : (
                                <QuadralButton
                                    label="Plein écran"
                                    title="Plein écran"
                                    color="secondary"
                                    disabled={!documentLink}
                                    style={{minWidth: '110px'}}
                                    onClick={() => openDocumentFullscreen?.(documentLink, 'Document PDF')}
                                    startIcon={<FontAwesomeIcon icon={faExpand}/>}
                                />
                            )}
                        </>)}
                        </QuadralContainer>
                        <QuadralTypography variant='cardTitle'>
                            Analyse par l'IA
                        </QuadralTypography>
                        <QuadralContainer orientation='row' className="d-flex mb-2 justify-content-between">
                            <QuadralContainer orientation='column' xl={8} className="d-flex align-items-center">
                                {confidenceIndex !== 'Inconnu' ?
                                    <QuadralBadge
                                        icon={<FontAwesomeIcon
                                            icon={(confidenceIndex >= 70) ? {faQuestion} : {faExclamation}}/>}
                                        label={`Indice de confiance ${confidenceIndex} %`.toUpperCase()}
                                        color={confidenceIndex >= 70 ? 'success' : 'error'}
                                    />
                                    :
                                    <QuadralBadge
                                        icon={<FontAwesomeIcon icon={faQuestion}/>}
                                        label={'Indice de confiance inconnu'.toUpperCase()}
                                        color='warning'
                                        style={{width: 'fit-content'}}
                                    />
                                }
                            </QuadralContainer>
                        </QuadralContainer>
                        {/*<QuadralContainer>
                            <QuadralTypography variant='smallCardTitle'>
                                <FontAwesomeIcon icon={faStar}/> Synthèse par l'IA
                            </QuadralTypography>
                            <QuadralCard
                                variant='small'
                                sx={{width: '100%'}}
                            >
                                'Ai content'
                            </QuadralCard>
                        </QuadralContainer> */}
                        <QuadralContainer>
                            <QuadralTypography variant='smallCardTitle'>
                                <FontAwesomeIcon icon={faListCheck}/>
                                Champs à vérifier
                                <QuadralTypography
                                    sx={{
                                        fontSize: '12px',
                                        fontWeight: '400',
                                        color: '#A1A3F7',
                                        cursor: 'pointer',
                                        '&:hover': {
                                            color: '#6365f1',
                                            textDecoration: 'underline'
                                        }
                                    }}
                                    onClick={(event) => {
                                        setAnchorEl(event.currentTarget);
                                        setShowHelpPopover(true);
                                    }}
                                >
                                    Comment ça marche ? Cliquez ici
                                </QuadralTypography>
                            </QuadralTypography>
                        </QuadralContainer>
                        <Popover
                            open={showHelpPopover}
                            anchorEl={anchorEl}
                            onClose={() => setShowHelpPopover(false)}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                        >
                            <div style={{maxWidth: '600px', padding: '16px'}}>
                                <QuadralTypography variant='popoverTitle' style={{ marginBottom: '8px' }}>
                                    Vérification des champs pré-complétés par l'IA - Comment ça marche ?
                                </QuadralTypography>
                                <QuadralTypography variant='popoverText' style={{ marginBottom: '8px' }}>
                                    <p>Il est possible que les champs listés ci-dessous aient été mal complétées par l'IA "(niveau de confiance inférieur à 75%)". Veuillez vous assurer que les informations complétées par l'IA correspondent bien aux informations présentes sur la pièce justificative concernée.</p>
                                    
                                    <p>• Si la saisie complétée par l'IA est correcte et le champ "Information du participant" est rempli, vous n'avez rien à faire.</p>
                                    
                                    <p>• Si la saisie complétée par l'IA est correcte mais le champ "Information du participant" n'est pas rempli, veuillez cliquer sur le bouton <FontAwesomeIcon icon={faCopy} /> afin de compléter le champ "Information du participant"</p>
                                    
                                    <p>• Si la saisie complétée par l'IA est incorrecte, veuillez saisir dans le champ "Information du participant" l'information telle qu'elle figure sur la pièce justificative.</p>
                                    
                                    <p>Une fois la vérification de chaque champ terminée, veuillez cliquer sur "Valider" ou "Refuser" la pièce justificative</p>
                                </QuadralTypography>
                            </div>
                        </Popover>
                        <QuadralContainer orientation='row' className="d-flex justify-content-between">
                            <QuadralContainer orientation='column' xl={8} className="d-flex align-items-center">
                                {document?.status === 'refuse' && document?.refusalReason !== null &&
                                    <QuadralTypography variant='smallCardTitle' style={{fontWeight: 'bold', color: themeColors.purple.main}}> 
                                        {`Motif de refus : `}
                                        <QuadralTypography variant='smallCardTitle'>
                                            {`${document?.refusalReason === 'autre' ? 'Autre motif'
                                                : document?.refusalReason === 'illisible' ? 'Document illisible'
                                                : document?.refusalReason === 'incomplet' ? 'Document incomplet'
                                                : document?.refusalReason === 'mauvais_document' ? 'Mauvais document'
                                                : (document?.refusalReason === 'mauvaise_periode') ? 'Mauvaise année'
                                                : (document?.refusalReason === 'mauvais_individu') ? 'Document d\'une autre personne'
                                                : (document?.refusalReason === 'correction_declaration') ? 'Correction déclaration' : ''}
                                            `}
                                        </QuadralTypography>
                                    </QuadralTypography>
                                }
                            </QuadralContainer>
                        </QuadralContainer>
                        <QuadralContainer orientation='row' className="d-flex justify-content-between">
                            <QuadralContainer orientation='column' xl={8} className="d-flex align-items-center">
                                {document?.status === 'refuse' && document.refusalReasonDetails && ![null, ''].includes(document.refusalReasonDetails) &&
                                    <QuadralTypography variant='smallCardTitle' style={{fontWeight: 'bold', color: themeColors.purple.main}}> 
                                        {`Détails : `}
                                        <QuadralTypography variant='smallCardTitle'>
                                            {document?.refusalReasonDetails}
                                        </QuadralTypography>
                                    </QuadralTypography>
                                }
                            </QuadralContainer>
                        </QuadralContainer>
                        <QuadralContainer orientation='row' className="d-flex mb-5 justify-content-between">
                            <QuadralContainer orientation='column' xl={8} className="d-flex align-items-center">
                                {[null, ''].includes(document?.comment) &&
                                    <QuadralTypography variant='smallCardTitle' style={{fontWeight: 'bold', color: themeColors.purple.main}}> 
                                        {`Commentaire : `}
                                        <QuadralTypography variant='smallCardTitle'>
                                            {document?.comment}
                                        </QuadralTypography>
                                    </QuadralTypography>
                                }
                            </QuadralContainer>
                        </QuadralContainer>
                        {document?.category === "RFR" && (analyzedFields?.length === 0 || status === 'Validé') && !isN3 && (
                            <QuadralContainer orientation='row' className="d-flex justify-content-between">
                                <QuadralContainer orientation='row' sx={{width: '100%', gap: '0.5rem', placeItems:'end'}}>
                                    <QuadralContainer orientation='column' sx={{flex: 7}}>
                                        <QuadralTextField
                                            label='Revenu fiscal de référence'
                                            name="rfr"
                                            value={detailFormData.rfr}
                                            onChange={(value) => handleRFRFields('rfr', value)}
                                            outerStyle={{width: '100%'}}
                                            noPadding
                                            noMargin
                                        />
                                    </QuadralContainer>
                                    <QuadralContainer orientation='column' sx={{flex: 5}}>
                                        <QuadralButton 
                                            label="Enregistrer"
                                            title="Enregistrer" 
                                            className="btn confirmation"
                                            style={{width: '100%'}}
                                            onClick={() => saveRFR()}
                                        />
                                    </QuadralContainer>
                                </QuadralContainer>
                            </QuadralContainer>
                        )}
                        {analyzedFields.length > 0 && fieldsToDisplay > 0 && vialinkResponse && (
                            <QuadralContainer orientation='row' sx={{overflowY: 'auto', borderRadius: 0}}>
                                <QuadralContainer orientation='column' sx={{gap: '0.625rem'}}>
                                    {Array.from(new Set(analyzedFields.map(field => field.name)))
                                    .filter((uniqueFieldName) => fieldNameMapping[uniqueFieldName])
                                    .map((uniqueFieldName, index) => {
                                        const translatedName = translateFieldName(uniqueFieldName);
                                        const fieldValue = analyzedFields.find(field => field.name === uniqueFieldName)?.value;
                                        const candidateField = translatePropertyName(uniqueFieldName);
                                        return (
                                            <QuadralContainer key={index}>
                                                <QuadralCard
                                                    title={<QuadralTypography variant='smallCardAltTitle'>{`${translatedName.toUpperCase()} :`}</QuadralTypography>}
                                                    variant='small'
                                                    sx={{width: '100%', backgroundColor: '#F7F9FC', border: '1px solid #C7D2FE'}}
                                                >
                                                    <QuadralForm sx={{placeItems: 'end'}}>
                                                        <Grid style={{display: 'flex', flexDirection: 'row', alignItems: 'end'}} size={{sm: 12, md: 6}}>
                                                            <QuadralTextField
                                                                label="Information extraite par l'IA"
                                                                id="extractedValue"
                                                                name="extractedValue"
                                                                value={fieldValue || 'Pas de données extraites'}
                                                                onChange={(value) => handleRFRFields('rfr', value)}
                                                                outerStyle={{width: '100%', paddingRight: '0px'}}
                                                                disabled
                                                                multiline
                                                                noMargin
                                                                maxRows={3}
                                                                sm={11} md={5}
                                                            />
                                                            <Grid size={{sm: 1, md: 1}} style={{ width: 'auto', marginLeft: '7px' }}>
                                                                <QuadralButtonIcon
                                                                    onClick={() => copyFieldValue(candidateField, fieldValue)}
                                                                    disabled={status === 'Validé' || fieldValue === null}
                                                                    style={{height: '43px'}}
                                                                icon={<FontAwesomeIcon icon={faCopy}/>}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                        <Grid style={{display: 'flex', flexDirection: 'row', alignItems: 'end'}} size={{sm: 12, md: 6}}>
                                                            {uniqueFieldName === "TAX_ASSESSMENT-CODE_2DDOC_FISCAL_EARNINGS_REFERENCE" ? (
                                                                <QuadralTextField
                                                                    label='Information du participant'
                                                                    id="rfrValue"
                                                                    name="rfrValue"
                                                                    disabled={status === 'Validé'}
                                                                    value={detailFormData.rfr || ''}
                                                                    onChange={(value) => handleRFRFields('rfr', value)}
                                                                    style={{backgroundColor: '#fff'}}
                                                                    multiline
                                                                    noMargin
                                                                    maxRows={3}
                                                                    sm={12} md={12}
                                                                />
                                                            ) : uniqueFieldName === "TAX_ASSESSMENT-CODE_2DDOC_INCOME_YEAR" ? (
                                                                <QuadralTextField
                                                                    label='Information du participant'
                                                                    id="yearValue"
                                                                    name="yearValue"
                                                                    disabled={status === 'Validé'}
                                                                    value={detailFormData.year || ''}
                                                                    onChange={(value) => handleRFRFields('year', value)}
                                                                    style={{backgroundColor: '#fff'}}
                                                                    multiline
                                                                    noMargin
                                                                    maxRows={3}
                                                                    sm={12} md={12}
                                                                />
                                                            ) : (
                                                                <QuadralTextField
                                                                    label='Information du participant'
                                                                    id="copiedValue"
                                                                    name="copiedValue"
                                                                    disabled={status === 'Validé'}
                                                                    value={personSheet[candidateField] || ''}
                                                                    onChange={(e) => setPersonSheet(prev => ({
                                                                        ...prev,
                                                                        [candidateField]: e
                                                                    }))}
                                                                    style={{backgroundColor: '#fff'}}
                                                                    multiline
                                                                    noMargin
                                                                    maxRows={3}
                                                                    sm={12} md={12}
                                                                />
                                                            )}
                                                        </Grid>
                                                    </QuadralForm>
                                                </QuadralCard>
                                            </QuadralContainer>
                                        );
                                    })}
                                </QuadralContainer>
                            </QuadralContainer>
                        )}
                        {analyzedFields.length === 0 && (
                                <div style={{
                                    margin: '3rem 1rem 0rem 1rem',
                                    borderRadius: '5px',
                                    padding: '10px',
                                    textAlign: 'center',
                                    backgroundColor: 'rgba(149, 30, 73, 0.15)'
                                }}>
                                    Aucune donnée extraite pour le moment
                                </div>
                        )}
                    </QuadralContainer>
                )}
                <QuadralModal
                    size='XL'
                    open={showRefuseModal}
                    setOpen={setShowRefuseModal}
                    title='Refuser une pièce'
                    noButton
                    action={<>
                        <QuadralButton
                            color='error'
                            onClick={() => {
                                emptyRefusalModal();
                                setShowRefuseModal(false);
                            }}
                        >
                            Annuler
                        </QuadralButton>
                        <QuadralButton
                            color='success'
                            onClick={() => {
                                setShowRefuseModal(false);
                                refuseSupportingDocument();
                            }}
                            disabled={!(refuseFormData.refusalReason && refuseFormData.refusalReason.trim() !== '')}
                        >
                            Confirmer la décision
                        </QuadralButton>
                    </>}
                >
                    <QuadralContainer>
                        <QuadralContainer orientation='row'>
                            <QuadralContainer orientation='column' xl={7}>
                                <QuadralAutocomplete
                                    aria-label="Select refusal reason"
                                    id="refusalReason"
                                    label='Motif'
                                    value={refusalReasonOptions.find(opt => opt.code === refuseFormData.refusalReason) || null}
                                    options={refusalReasonOptions}
                                    getOptionLabel={(option) => option.label}
                                    required
                                    onChange={(e, value) => handleField('refusalReason', value?.code)}
                                />
                            </QuadralContainer>
                            <QuadralContainer orientation='column' xl={4}
                                              style={{marginTop: '2rem', marginLeft: '2rem'}}>
                                <QuadralButton
                                    label="Réassigner la pièce"
                                    disabled={(status === 'Validé' || status === 'A fournir' || status === 'Inconnu')}
                                    color='secondary'
                                    onClick={() => {
                                        setShowRefuseModal(false);
                                        displayDisassociationModal(true);
                                    }}
                                />
                            </QuadralContainer>
                        </QuadralContainer>
                        <QuadralContainer orientation='row'>
                            <QuadralContainer orientation='column'>
                                <QuadralTextField
                                    label='Détails'
                                    id="refusalReasonDetails"
                                    name="refusalReasonDetails"
                                    value={refuseFormData.refusalReasonDetails}
                                    onChange={(value) => handleField('refusalReasonDetails', value)}
                                    multiline
                                />
                                </QuadralContainer>
                        </QuadralContainer>
                    </QuadralContainer>
                </QuadralModal>
                <QuadralModal
                    size='XL'
                    open={showDisassociationModal}
                    setOpen={setShowDisassociationModal}
                    title="Réassignation d'un document"
                    noButton
                    action={<>
                        <QuadralButton
                            color='error'
                            onClick={() => {
                                setShowDisassociationModal(false);
                            }}
                        >
                            Annuler
                        </QuadralButton>
                        <QuadralButton
                            color='success'
                            onClick={() => {
                                setShowDisassociationModal(false);
                                reassignDocument();
                            }}
                        >
                            Confirmer la décision
                        </QuadralButton>
                    </>}
                >
                    <QuadralContainer>
                        <QuadralContainer orientation='column'>
                            <p style={{margin: 'auto 15px'}}>Le document actuellement associé à la pièce justificative
                                va être dissocié.</p>
                            <p style={{margin: 'auto 15px'}}>La pièce justificative sera alors marquée comme "À
                                fournir".</p>
                            <p style={{margin: 'auto 15px'}}>Vous pourrez retrouver le document dans la "Boîte de
                                tri", en haut de la liste des documents, sous le nom "{props?.document?.name}.pdf",
                                afin de le réassigner.</p>
                            <p style={{margin: 'auto 15px'}}>Veuillez confirmer.</p>
                        </QuadralContainer>
                    </QuadralContainer>
                </QuadralModal>
            </QuadralContainer>

        </>
    )
}